import { IOmniaShell } from "@omnia/types"
import { IDashboardService } from "../types"
import { Card } from "@omnia/shared/react/Card"
import { useAsyncValue } from "@omnia/shared/react/hooks"
import { sortBy } from "@omnia/shared/utils/array"
import { formatDateToLocale } from "@omnia/shared/utils/date"
import { formatToReadable } from "@omnia/shared/utils/format"

interface Props {
    svc: IDashboardService
    shell: IOmniaShell
    update(run?: () => void): void
}

export function SeedPlansCard({svc, shell, update}: Props) {

    const plansInfo = useAsyncValue(() => svc.ensureInit().then(() => {
        const plans = sortBy(svc.getSeedPlans(), ['PlanName', 'Date']);
        const canManage = svc.permissions.seedPlans.read;

        return {
            seedPlans: plans,
            canManage: canManage
        };
    }), [svc, svc.yearId, svc.stateVersion]);

    const cardTools = plansInfo?.canManage
        ? <div className="btn-group">
                <button className="btn btn-link btn-icon-toggle" onClick={() => update(() => shell.navigate("/seeds"))} title="Manage plans">
                    <i className="fas fa-pen"></i>
                </button>
            </div>
        : null;

    return <Card icon="icon icon-reco-seeds" title="Seed plans" small={false} headerTools={cardTools} isCollapsible={true} >
        <div className="row">
            <table className="omnia-table">
                <thead>
                    <tr>
                        <th>Plan</th>
                        <th>Date</th>
                        <th>Crop/variety</th>
                        <th>Quantity</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {plansInfo?.seedPlans.map((plan, index) => (
                        <tr key={index}>
                            <td>{plan.PlanName}</td>
                            <td>{formatDateToLocale(plan.Date)}</td>
                            <td>{plan.ProductName}</td>
                            <td>{!!plan.Quantity ? `${formatToReadable(plan.Quantity)} ${plan.Unit}` : '-'}</td>
                            <td>
                                <button className="btn btn-link btn-icon-toggle" onClick={() => update(() => shell.navigate(`/seeds/edit-plan/${plan.PlanId}`))}
                                    title="Manage plan">
                                    <i className="fas fa-pen"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </Card>;
}